module.exports = __webpack_public_path__ + "assets/fonts/src/assets/fonts/National2Condensed-Bold.otf";